import { Turnstile } from "@marsidev/react-turnstile";
import { turnstileSiteKey } from "../turnstileConfig";

/**
 * Managed Turnstile widget. Omit when REACT_APP_TURNSTILE_SITE_KEY is unset.
 * Use widgetKey to force reset after an action (e.g. resend).
 *
 * When `tokenSessionId` is a number, callbacks are `onTokenChange(token, tokenSessionId)` so the
 * parent can ignore stale events from a previous iframe after remount (single-use tokens).
 *
 * Defaults: `responseField: false` (token is sent via API JSON only — avoids hidden inputs inside
 * customer `<form>` and related browser quirks). Do not default `appearance: interaction-only` here:
 * it can leave the widget blank for some site/widget/host combinations.
 */
export default function TurnstileField({
  onTokenChange,
  onWidgetError,
  widgetKey = "default",
  tokenSessionId,
  options: optionsProp,
  id,
  className,
}) {
  if (!turnstileSiteKey) return null;

  const report = (token) => {
    if (typeof tokenSessionId === "number") {
      onTokenChange(token, tokenSessionId);
    } else {
      onTokenChange(token);
    }
  };

  const options = {
    responseField: false,
    theme: "light",
    ...(optionsProp && typeof optionsProp === "object" ? optionsProp : {}),
  };

  return (
    <div className={className ? `turnstile-field ${className}` : "turnstile-field"}>
      <Turnstile
        key={widgetKey}
        id={id || `turnstile-${widgetKey}`}
        siteKey={turnstileSiteKey}
        options={options}
        onSuccess={(token) => report(token)}
        onExpire={() => report(null)}
        onError={(error) => {
          report(null);
          if (typeof onWidgetError === "function") {
            onWidgetError(error);
          }
        }}
      />
    </div>
  );
}
